// import * as React from "react";
// import { useEffect } from "react";
import {
  faIR,
  GridDeleteIcon,
  GridAddIcon,
  GridDragIcon
} from "@mui/x-data-grid";
// import { useDispatch, useSelector } from "react-redux";
// import { Box, Grid,Typography, IconButton, Button } from "@mui/material";
// import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
// import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
// import AcUnitTwoToneIcon from "@mui/icons-material/CallToAction";
// import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
// import { setinitialStateR } from "../../../components/Login/LoginSlice/LoginSlice";
// import "./style.css";
// import {
//   GridToolbarContainer,
//   GridToolbarColumnsButton,
//   GridToolbarFilterButton,
//   GridToolbarExport,
//   GridToolbarDensitySelector,
// } from "@mui/x-data-grid";
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import { useTheme } from '@mui/material/styles';
// //  export default function CustomToolbarGrid() {
// //       const { data } = useDemoData({
// //         dataSet: 'Commodity',
// //         rowLength: 10,
// //         maxColumns: 6,
// //       });
// // setShowToolbarModal={setShowModal}
// // showInformation={showModal}

// export default function DyDataGridCustom({
//   data = [],
//   columns = [],
//   hideFooter,
//   selectionModel,
//   initialOnRowClick,
//   rowSelection,
//   rowHeight,
//   onRowSelectionEvent,
//   initState,
//   setSelectionModel,
//   setShowHistory,
//   additionalToolbar,
//   setShowInformation,
//   setSpecialId,
//   setShowAddEvalModal,
//   initialDelete,
//   setShowActionsModal,
//   initialMount,
//   setPointSys,
//   drName,
//   setRowSelectedData,
//   withoutOptions,
// }: any) {
//   const [selectedRowData, setSelectedRowData] = React.useState(null);
  
//   const [open, setOpen] = React.useState(false);
//   const theme = useTheme();
//   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };
  
//   function CustomToolbar() {
//     return (
//       <GridToolbarContainer>
//         <Grid>
//           {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={() => {
//                 setShowHistory((prev: any) => !prev);
//                 let { id } = selectedRowData;
//                 setSpecialId(id);
//               }}
//               startIcon={<HistoryToggleOffIcon />}
//             >
//               {/* تاریخچه */}
//               ویرایش
//             </Button>
//           )}
//           {/* {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={() => {
//                 setShowInformation((prev: any) => !prev);
//                 console.log(selectedRowData);
//                 initialOnRowClick(selectedRowData);
//               }}
//               startIcon={<GridDeleteIcon />}
//             > */}
//               {/* اطلاعات */}
//               {/* حذف
//             </Button>
//           )} */}
//                     {selectedRowData && additionalToolbar && (

//             <Dialog
//         fullScreen={fullScreen}
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="responsive-dialog-title"
//       >
//         <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
//         {"آیا از حذف اطمینان دارید؟"}
//         </DialogTitle>
//         {/* <DialogContent>
//         </DialogContent> */}
//         <DialogActions>
//           <Button autoFocus onClick={handleClose}>
//           <Typography  color={'red'}> انصراف</Typography> 
//           </Button>
//           <Button       onClick={() => {
//                 //setShowAddEvalModal((prev: any) => !prev);
//                 let { id } = selectedRowData;
//                 setSpecialId(id);
//                 initialDelete();
//                 handleClose()
//               }} autoFocus >
//           <Typography  color={'#00387C'} > تایید</Typography> 
//           </Button>
//         </DialogActions>
//       </Dialog>
//         )}
//           {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={handleClickOpen}
              
//               // onClick={() => {
//               //   //setShowAddEvalModal((prev: any) => !prev);
//               //   let { id } = selectedRowData;
//               //   setSpecialId(id);
//               //   initialDelete();
//               // }}
//               startIcon={<GridDeleteIcon />}
//             >
//               {/* ارزیابی قبل جلسه */}
//               حذف
//             </Button>
//           )}
//           {/* {selectedRowData && additionalToolbar && (
//             <Button
//               sx={{ fontSize: "10px" }}
//               variant="text"
//               onClick={() => {
//                 setShowActionsModal((prev: any) => !prev);
//                 let { id } = selectedRowData;
//                 setSpecialId(id);
//               }}
//               startIcon={<AcUnitTwoToneIcon />}
//             >
//           اقدامات
//             </Button>
//           )} */}
//         </Grid>
//         <GridToolbarColumnsButton />
//         <GridToolbarFilterButton />
//         <GridToolbarDensitySelector />
//         {/* <GridToolbarExport /> */}
//       </GridToolbarContainer>
//     );
//   }

//   const initOnRowClick = (row: any) => {
//     // console.log(pram)
//     // console.log(row.api.getAllRowIds().indexOf(row.id)+1)
//     // params.api.getAllRowIds().indexOf(params.id)+1
//     setSelectionModel(row.id);

//     setSelectedRowData(row);

//     initialOnRowClick(row);
//     if (setPointSys) {
//       setPointSys(row?.okR_KeyResultType);
//     }

//     if (setRowSelectedData) {
//       setRowSelectedData(row);
//     }
//   };

//   useEffect(() => {
//     // console.log("dataLoad", data);

//     if (initialMount) {
//       setSelectedRowData(data[0]);
//       // setSelectionModel(data[0]?.id)
//       initialOnRowClick(data[0]);
//     }

//     if (setPointSys) {
//       setPointSys(data[0]?.okR_KeyResultType);
//     }

//     if (setRowSelectedData) {
//       setRowSelectedData(data[0]);
//     }
//   }, []);

//   const dispatch = useDispatch();

//   const initialChangestate = (data: any) => {
//     // console.log("data", data);
//     if (drName && data) {
//       let columnVisibilityModel = data?.columns?.columnVisibilityModel;

//       try {
//         dispatch(
//           setinitialStateR({ name: drName, colVis: columnVisibilityModel })
//         );
//       } catch (error) {
//         console.log(error);
//       }
//     }
//   };

//   return (
//     <Grid width={"100%"}>
//       <DataGrid
//         onStateChange={(state) => {
//           initialChangestate(state);
//         }}
//         density="compact"
//         initialState={initState}
//         slots={{ toolbar: withoutOptions ? null : CustomToolbar }}
//         rowHeight={40}
//         sx={{
//           cursor: "pointer",
//           border: 0,
//           "& .MuiDataGrid-columnSeparator": {
//             display: "none!important",
//           },
//           "& .MuiDataGrid-root": {
//             backgroundColor: "#00387C !important",
//             color: "white",
//             borderRadius: 4,
//             cursor: "pointer",
//             border: 0,
//             "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
//               fontSize: "10px", // Adjust the font size as needed
//             },
//             "& .rtl-128fb87-MuiDataGrid-toolbarContainer": {
//               alignSelf: "end",
//               pb: 2,
//             },
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             width: "100%",
//             position: "sticky",
//             zIndex: "1000",
//             background: "#00387C !important",
//             color: "white",
//           },
//         }}
//         hideFooter={hideFooter}
//         autoHeight
//         localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
//         rowSelectionModel={selectionModel}
//         rows={data ? data : []}
//         columns={columns}
//         disableColumnMenu
//         // disableColumnFilter
//         checkboxSelection={rowSelection ? rowSelection : false}
//         rowSelection={true}
//         onRowClick={(param) => {
//           initOnRowClick(param.row);
//         }}
//         // cell
//       />
//     </Grid>
//   );
// }

//****************** */
import * as React from "react";
import { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbar,
} from "@mui/x-data-grid";
import { useDispatch } from "react-redux";
import { Grid, Typography, Button, TextField } from "@mui/material";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import { setinitialStateR } from "../../../components/Login/LoginSlice/LoginSlice";
import "./style.css";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function DyDataGridCustom({
  data = [],
  columns = [],
  hideFooter,
  initialOnRowClick,
  initState,
  additionalToolbar,
  setShowHistory,
  setSpecialId,
  setSelectedIds,
  initialDelete,
  initialAddToMyList,
  initialRemoveToMyList,
  initialAddToTenantList,
  initialRemoveToTenantList,
}: any) {
  const [searchText, setSearchText] = useState(""); // اضافه کردن state برای جستجو
  const [filteredData, setFilteredData] = useState(data); // داده‌های فیلتر شده
  const [selectedRowData, setSelectedRowData] = React.useState<any>([]);
  const [selectionModel, setSelectionModelState] = React.useState<string[]>([]);
  // const [selectedIds,setSelectedIds ] = useState<string[]>([]); 
  // متغیر برای ذخیره ID سطرهای انتخاب شده
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  // ترکیب کردن وضعیت پیش‌فرض با داده‌های ذخیره شده در localStorage
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => {
    const savedVisibility = localStorage.getItem('columnVisibility');
    const defaultVisibility = {
      type1: false, 
      type2: false, 
      period: false, 
      recommenderTenant: false, 
      status: false, 
      useType: false, 
    };

    // اگر داده‌ای در localStorage موجود باشد آن را بازیابی می‌کند، در غیر این صورت مقادیر پیش‌فرض را برمی‌گرداند
    return savedVisibility ? JSON.parse(savedVisibility) : defaultVisibility;
  });

  const handleColumnVisibilityChange = (newModel: any) => {
    setColumnVisibilityModel(newModel);
    // ذخیره مدل جدید در localStorage
    localStorage.setItem('columnVisibility', JSON.stringify(newModel));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const columnsVisibilityModell = {
    type1: false, // این ستون مخفی است
    type2: true  // این ستون قابل نمایش است
  };
  // فیلتر کردن داده‌ها بر اساس متن جستجو
  useEffect(() => {
    setFilteredData(
      data.filter((item :any) =>
        Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchText.toLowerCase())
        )
      )
    );
  }, [searchText, data]);

  useEffect(() => {
    if (selectionModel.length > 0) {
      const selectedRowData = data.filter((row: any) =>
        selectionModel.includes(row.id)
      );
      setSelectedRowData(selectedRowData);
      setSelectedIds(selectionModel); // اطمینان از بروزرسانی انتخاب‌ها
    }
  }, [selectionModel, data]);

  function CustomToolbar() {
    const isSingleSelection = selectionModel.length === 1;

    return (
      <GridToolbarContainer>
        <Grid>
          {isSingleSelection && additionalToolbar && (
            <Button
              // sx={{ fontSize: "10px", bgcolor: 'withesmoke', color:'blue'  }}
              sx={{
                fontSize: "10px",
                marginRight: "5px",
                bgcolor: 'white',    // پس‌زمینه سفید
                color: 'blue',    // متن سبز
                border: '2px solid blue',  // دور سبز
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',  // برای ایجاد انیمیشن تغییر سایز و سایه
                '&:active': {
                  bgcolor: 'white',  // حفظ پس‌زمینه سفید هنگام hover
                  color: 'blue',  // حفظ رنگ متن سبز هنگام hover
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',  // ایجاد سایه هنگام hover
                },
                '&:hover': {
                  transform: 'scale(1.1)',   // بزرگتر شدن هنگام کلیک
                  boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',  // سایه بیشتر هنگام کلیک
                },
              }}
              variant="text"
              onClick={() => {
                setShowHistory((prev: any) => !prev);
                let { id } = selectedRowData[0];
                setSpecialId(id);
              }}
              startIcon={<HistoryToggleOffIcon />}
            >
              ویرایش
            </Button>
          )}
          {isSingleSelection && additionalToolbar && (
            <>
              <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
              >
                <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
                  {"آیا از حذف اطمینان دارید؟"}
                </DialogTitle>
                <DialogActions>
                  <Button autoFocus onClick={handleClose}>
                    <Typography color={'red'}> انصراف</Typography> 
                  </Button>
                  <Button
                    onClick={() => {
                      let { id } = selectedRowData[0];
                      setSpecialId(id);
                      initialDelete();
                      handleClose();
                    }}
                    autoFocus
                  >
                    <Typography color={'#00387C'}> تایید</Typography> 
                  </Button>
                </DialogActions>
              </Dialog>
              {/* <Button
                //sx={{ fontSize: "10px" , bgcolor: 'red', color:'white' }}
                sx={{
                  fontSize: "10px",
                  marginRight:"5px",
                  bgcolor: '#ff5959',
                  color: 'white',
                  '&:hover': {
                    bgcolor: '#fe0000',  // تغییر رنگ پس‌زمینه هنگام hover
                    color: 'white',         // تغییر رنگ متن هنگام hover
                  },
                }}
                variant="text"
                onClick={handleClickOpen}
                startIcon={<GridDeleteIcon />}
              >
                حذف
              </Button> */}
              <Button
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: '#fe0000',    // متن قرمز
                  border: '2px solid #fe0000',  // دور قرمز
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',  // برای ایجاد انیمیشن تغییر سایز و سایه
                  '&:active': {
                    bgcolor: 'white',  // حفظ پس‌زمینه سفید هنگام hover
                    color: '#fe0000',  // حفظ رنگ متن قرمز هنگام hover
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',  // ایجاد سایه هنگام hover
                  },
                  '&:hover': {
                    transform: 'scale(1.1)',   // بزرگتر شدن هنگام کلیک
                    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',  // سایه بیشتر هنگام کلیک
                  },
                }}
                variant="text"
                onClick={handleClickOpen}
                startIcon={<GridDeleteIcon />}
              >
                حذف
              </Button>
            </>
          )}
          {selectionModel.length > 0 && (
            <>
              <Button
                // sx={{
                //   fontSize: "10px",
                //   bgcolor: '#fca32a',
                //   marginRight:"5px",
                //   color: 'white',
                //   '&:hover': {
                //     bgcolor: '#ffbb61',  // تغییر رنگ پس‌زمینه هنگام hover
                //     color: 'white',         // تغییر رنگ متن هنگام hover
                //   },
                // }}
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: '#038900',    // متن سبز
                  border: '2px solid #00a000',  // دور سبز
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',  // برای ایجاد انیمیشن تغییر سایز و سایه
                  '&:active': {
                    bgcolor: 'white',  // حفظ پس‌زمینه سفید هنگام hover
                    color: '#00a000',  // حفظ رنگ متن سبز هنگام hover
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',  // ایجاد سایه هنگام hover
                  },
                  '&:hover': {
                    transform: 'scale(1.1)',   // بزرگتر شدن هنگام کلیک
                    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',  // سایه بیشتر هنگام کلیک
                  },
                }}
                variant="text"
                startIcon={<GridAddIcon />}
                onClick={() => {
                  setSelectedIds(selectionModel);
                  initialAddToTenantList();
                }}
              >
                 افزودن به لیست شرکت
              </Button>
              <Button
                // sx={{
                //   fontSize: "10px",
                //   bgcolor: '#6174ff',
                //   marginRight:"5px",
                //   color: 'white',
                //   '&:hover': {
                //     bgcolor: '#8d9bfc',  // تغییر رنگ پس‌زمینه هنگام hover
                //     color: 'white',         // تغییر رنگ متن هنگام hover
                //   },
                // }}
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: '#038900',    // متن سبز
                  border: '2px solid #00a000',  // دور سبز
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',  // برای ایجاد انیمیشن تغییر سایز و سایه
                  '&:active': {
                    bgcolor: 'white',  // حفظ پس‌زمینه سفید هنگام hover
                    color: '#00a000',  // حفظ رنگ متن سبز هنگام hover
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',  // ایجاد سایه هنگام hover
                  },
                  '&:hover': {
                    transform: 'scale(1.1)',   // بزرگتر شدن هنگام کلیک
                    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',  // سایه بیشتر هنگام کلیک
                  },
                }}
                variant="text"
                startIcon={<GridAddIcon />}
                onClick={() => {
                  setSelectedIds(selectionModel);
                  initialAddToMyList();
                }}
              >
                 افزودن به لیست من
              </Button>
              <Button
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: '#fe0000',    // متن قرمز
                  border: '2px solid #fe0000',  // دور قرمز
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',  // برای ایجاد انیمیشن تغییر سایز و سایه
                  '&:active': {
                    bgcolor: 'white',  // حفظ پس‌زمینه سفید هنگام hover
                    color: '#fe0000',  // حفظ رنگ متن قرمز هنگام hover
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',  // ایجاد سایه هنگام hover
                  },
                  '&:hover': {
                    transform: 'scale(1.1)',   // بزرگتر شدن هنگام کلیک
                    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',  // سایه بیشتر هنگام کلیک
                  },
                }}
                variant="text"
                startIcon={<GridDeleteIcon />}
                onClick={() => {
                  setSelectedIds(selectionModel);
                  initialRemoveToTenantList();
                }}
              >
                 حدف از لیست شرکت
              </Button>
              <Button
                sx={{
                  fontSize: "10px",
                  marginRight: "5px",
                  bgcolor: 'white',    // پس‌زمینه سفید
                  color: '#fe0000',    // متن قرمز
                  border: '2px solid #fe0000',  // دور قرمز
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',  // برای ایجاد انیمیشن تغییر سایز و سایه
                  '&:active': {
                    bgcolor: 'white',  // حفظ پس‌زمینه سفید هنگام hover
                    color: '#fe0000',  // حفظ رنگ متن قرمز هنگام hover
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',  // ایجاد سایه هنگام hover
                  },
                  '&:hover': {
                    transform: 'scale(1.1)',   // بزرگتر شدن هنگام کلیک
                    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.3)',  // سایه بیشتر هنگام کلیک
                  },
                }}
                variant="text"
                startIcon={<GridDeleteIcon />}
                onClick={() => {
                  setSelectedIds(selectionModel);
                  initialRemoveToMyList();
                }}
              >
                 حذف از لیست من
              </Button>
            </>
          )}
        </Grid>
        <GridToolbarColumnsButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarFilterButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarDensitySelector sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />

      </GridToolbarContainer>
    );
  }

  const initOnRowClick = (row: any) => {
    setSelectionModelState([row.id]);
    setSelectedRowData([row]);
    initialOnRowClick(row);
  };

  useEffect(() => {
    if (data.length > 0) {
      setSelectedRowData([data[0]]);
      initialOnRowClick(data[0]);
    }
  }, []);

  const dispatch = useDispatch();

  const initialChangestate = (data: any) => {
    if (data) {
      let columnVisibilityModel = data?.columns?.columnVisibilityModel;
      try {
        dispatch(
          setinitialStateR({ name: "yourDrName", colVis: columnVisibilityModel })
        );
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Grid width={"100%"}>
            <div style={{ height: 450, width: '100%' }}> 
      <DataGrid
        onStateChange={(state) => {
          initialChangestate(state);
        }}
        density="compact"
        initialState={initState}
        slots={{ toolbar: CustomToolbar }}
        rowHeight={40}
        sx={{
          cursor: "pointer",
          border: 0,
          "& .MuiDataGrid-columnSeparator": {
            display: "none!important",
          },
          "& .MuiDataGrid-root": {
            backgroundColor: "#00387C !important",
            color: "white",
            borderRadius: 4,
            cursor: "pointer",
            border: 0,
            "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
              fontSize: "10px",
            },
            "& .rtl-128fb87-MuiDataGrid-toolbarContainer": {
              alignSelf: "end",
              pb: 2,
            },
          },
          "& .MuiDataGrid-columnHeaders": {
            width: "100%",
            position: "sticky",
            zIndex: "1000",
            background: "#00387C !important",
            color: "white",
          },
          // "& .MuiDataGrid-row:nth-of-type(odd)": {
          //   backgroundColor: "#f5f5f5",  // رنگ پس‌زمینه برای سطرهای فرد
          // },
          // "& .MuiDataGrid-row:nth-of-type(even)": {
          //   backgroundColor: "#ffffff",  // رنگ پس‌زمینه برای سطرهای زوج
          // },
        }}
        hideFooter={hideFooter}
        autoHeight={false}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        rows={filteredData} // استفاده از داده‌های فیلتر شده
        columns={columns}
        columnVisibilityModel={columnVisibilityModel} // تنظیم مدل نمایش ستون‌ها
        onColumnVisibilityModelChange={handleColumnVisibilityChange} // ذخیره‌سازی تغییرات        onColumnVisibilityModelChange={(newModel:any) => setColumnVisibilityModel(newModel)} // مدیریت تغییرات
        disableColumnMenu
        checkboxSelection
        //قبلی
        // onRowSelectionModelChange={(newSelectionModel :any) => {
        //   setSelectionModelState(newSelectionModel);
        //   const selectedRowData = data.filter((row :any) =>
        //     newSelectionModel.includes(row.id)
        //   );
        //   setSelectedRowData(selectedRowData);
        // }}
        //جدید
        onRowSelectionModelChange={(newSelectionModel: any) => {
          setSelectionModelState(newSelectionModel); // بروزرسانی selectionModel
        }}
        onRowClick={(param) => {
          initOnRowClick(param.row);
        }}
      />
            </div>

    </Grid>
  );
}

